module.exports = __webpack_public_path__ + "static/media/Soccer Player.c727344c.jpg";